/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from "react";
import "../Styles/ToDo.css";
import { useConfig } from "../../context/ConfigContext";

export default function TodoTab() {
  const { config } = useConfig();
  const apiUrl = config.REACT_APP_TODOS;
  const apiKey = config.REACT_APP_API_KEY;

  const [todos, setTodos] = useState([]);
  const [newText, setNewText] = useState("");
  const [loading, setLoading] = useState(false);

  const headers = useMemo(() => ({
    "Api-Key": apiKey,
    "Content-Type": "application/json",
  }), [apiKey]);

  const loadTodos = async () => {
    try {
      const res = await fetch(`${apiUrl}`, { headers, credentials: "include" });
      const data = await res.json();

      setTodos(data);
    } catch (err) {
      console.error("Failed to load todos", err);
    }
  };

  useEffect(() => {
    loadTodos();
  }, []);

  const addTodo = async () => {
    if (!newText.trim()) return;
    setLoading(true);
    try {
      await fetch(`${apiUrl}`, {
        method: "POST",
        headers,
        body: JSON.stringify({ text: newText }), credentials: "include"
      });
      setNewText("");
      await loadTodos();
    } finally {
      setLoading(false);
    }
  };

  const toggleTodo = async (id, completed) => {
    try {
      await fetch(`${apiUrl}/${id}`, {
        method: "PATCH",
        headers,
        body: JSON.stringify({ completed }), credentials: "include"
      });
      await loadTodos();
    } catch (err) {
      console.error(err);
    }
  };

  const deleteTodo = async (id) => {
    try {
      await fetch(`${apiUrl}/${id}`, {
        method: "DELETE",
        headers,
        credentials: "include"
      });
      await loadTodos();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="card-grid">
      <section className="card">
        <h2>📝 To-Do List</h2>

        <div className="todo-add">
                  <textarea
                      className="input todo-input"
                      placeholder="New task... (Shift + Enter for new line)"
                      value={newText}
                      rows={1}
                      onChange={(e) => {
                        setNewText(e.target.value)
                          e.target.style.height = "auto";
                          e.target.style.height = `${e.target.scrollHeight}px`;
                      }}
                      onKeyDown={(e) => {
                          // Shift + Enter → New line
                          if (e.key === "Enter" && e.shiftKey) {
                              e.preventDefault();
                              setNewText((prev) => prev + "\n");
                              return;
                          }

                          // Enter (no shift) → Add todo
                          if (e.key === "Enter") {
                              e.preventDefault();
                              addTodo();
                          }
                      }}
                  />
          <button className="btn primary" onClick={addTodo} disabled={loading}>
            Add
          </button>
        </div>

        <div className="todo-list">
          {todos.length === 0 && (
            <p className="muted">No tasks yet.</p>
          )}

          {todos.map((t) => (
            <div key={t._id} className="todo-item todo-pop">
              <label className="todo-check">
                <input
                  type="checkbox"
                  checked={t.completed}
                  onChange={(e) => toggleTodo(t._id, e.target.checked)}
                />
                <span className={t.completed ? "done" : ""}>{t.text}</span>
              </label>

              <button className="btn danger" onClick={() => deleteTodo(t._id)}>
                ✕
              </button>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}